import React, { useState } from "react";
import { api } from "../api/api";
import ThemeToggle from "./ThemeToggle";

export default function AddUser({ onGoToLogin, embedded = false }) {
  const [form, setForm] = useState({ username: "", password: "", full_name: "", email: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setSuccess(""); setBusy(true);
    try {
      await api.register(form);
      setSuccess(`User "${form.username}" created.`);
      setForm({ username: "", password: "", full_name: "", email: "" });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={embedded ? {} : styles.wrap}>
      {!embedded && <ThemeToggle />}
      <form style={embedded ? styles.embeddedCard : styles.card} onSubmit={submit}>
        {!embedded && <div style={styles.brand}>AlgoDesk</div>}
        <div style={styles.sub}>{embedded ? "Add a new user" : "Create your account"}</div>

        <label style={styles.label}>Username</label>
        <input style={styles.input} value={form.username} onChange={set("username")} required />

        <label style={styles.label}>Password</label>
        <input style={styles.input} type="password" value={form.password} onChange={set("password")} required />

        <label style={styles.label}>Full name</label>
        <input style={styles.input} value={form.full_name} onChange={set("full_name")} />

        <label style={styles.label}>Email</label>
        <input style={styles.input} type="email" value={form.email} onChange={set("email")} />

        {error && <div style={styles.error}>{error}</div>}
        {success && <div style={styles.success}>{success}</div>}

        <button style={styles.button} disabled={busy}>
          {busy ? "Creating..." : "Create User"}
        </button>

        {!embedded && (
          <div style={styles.footer}>
            Already have an account?{" "}
            <span style={styles.link} onClick={onGoToLogin}>Log in</span>
          </div>
        )}
      </form>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    background: "var(--bg)",
  },
  card: {
    width: 340, background: "var(--panel)", border: "1px solid var(--border)",
    borderRadius: 10, padding: "32px 28px", display: "flex", flexDirection: "column",
  },
  embeddedCard: { width: 320, display: "flex", flexDirection: "column" },
  brand: { fontFamily: "var(--font-mono)", fontSize: 22, fontWeight: 600, letterSpacing: 0.5 },
  sub: { color: "var(--text-dim)", fontSize: 12, marginTop: 4, marginBottom: 20 },
  label: { fontSize: 11, color: "var(--text-dim)", marginTop: 12, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 },
  input: {
    background: "var(--panel-alt)", border: "1px solid var(--border)", borderRadius: 6,
    color: "var(--text)", padding: "9px 10px", fontSize: 13,
  },
  button: {
    marginTop: 20, background: "var(--accent)", color: "#04140a", border: "none",
    borderRadius: 6, padding: "10px 0", fontWeight: 600, cursor: "pointer", fontSize: 13,
  },
  error: { color: "var(--danger)", fontSize: 12, marginTop: 12 },
  success: { color: "var(--accent)", fontSize: 12, marginTop: 12 },
  footer: { marginTop: 18, fontSize: 12, color: "var(--text-dim)", textAlign: "center" },
  link: { color: "var(--focus)", cursor: "pointer" },
};
